import moment from 'moment';
import * as React from 'react';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { useTheme } from 'styled-components';
import * as Types from '../../../types';
import { getReadableIdWithDash } from '../../../types';
import {
  OldAuditEntryContainer,
  OldAuditEntryContent,
  OldAuditEntryIcon,
  OldAuditEntryIconContainer,
  OldAuditEntryText,
  OldAuditEntryVerticalLine,
} from './OldAuditLogEntry.styles';

export interface OldAuditLogEntryProps {
  auditEntry: Types.AuditEntry;
  iconSrc: string;
  iconAlt: string;
  color: string;
  lastAuditEntry: boolean;
  children: React.ReactNode;
  reverseColor?: boolean;
}

export const OldAuditLogEntry = (props: OldAuditLogEntryProps) => {
  const theme = useTheme();
  return (
    <OldAuditEntryContainer data-testid={'audit-log-entry'}>
      <OldAuditEntryIconContainer>
        <OldAuditEntryIcon>
          <StyledIcon
            className={props.iconSrc}
            size="24px"
            color={theme.atlas.semantic.color.surface.default}
          />
        </OldAuditEntryIcon>
        {!props.lastAuditEntry && <OldAuditEntryVerticalLine />}
      </OldAuditEntryIconContainer>

      <OldAuditEntryContent>
        <div>
          {moment(props.auditEntry.createdAt)
            .local()
            .format('DD/MMM/YYYY HH:mm')
            .toUpperCase()}
        </div>
        <OldAuditEntryText
          completed={props.auditEntry.completed}
          color={props.color}
          reverseColor={props.reverseColor}
          data-testid={`auditEntry/${props.auditEntry.id}`}
        >
          {props.children}
          {!props.auditEntry.completed && ' due to an error'}
        </OldAuditEntryText>
        <div>{getReadableIdWithDash(props.auditEntry.data.report ?? '')}</div>
      </OldAuditEntryContent>
    </OldAuditEntryContainer>
  );
};
